import React from 'react'
import AniLink from "gatsby-plugin-transition-link/AniLink"

class SectionHeader extends React.Component {
    render() {
        return <AniLink cover bg="#f5587b" style={{ textDecoration: 'none' }} to={ this.props.to }>
            <div className="sectionHeader">
                <h2>{ this.props.title }</h2>
                <div style={{ fontWeight: 'bold', textAlign: 'right', minWidth: 80 }}>View All ›</div>
            </div>
        </AniLink>
    }
}

export default SectionHeader  
